import { render, staticRenderFns } from "./CompanyPanel.vue?vue&type=template&id=3545975b&scoped=true&"
import script from "./CompanyPanel.vue?vue&type=script&lang=js&"
export * from "./CompanyPanel.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPanel.vue?vue&type=style&index=0&id=3545975b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3545975b",
  null
  
)

export default component.exports